import types from '@/vuex/ui/actions-types'
import informacao from '@/utils/informacao'

const actions = {
  [types.SHOW_GLOBAL_LOADING]: ({ commit }, payload) => {
    commit(types.SHOW_GLOBAL_LOADING, payload)
  },
  [types.HIDE_GLOBAL_LOADING]: ({ commit }) => {
    commit(types.HIDE_GLOBAL_LOADING)
  },
  [types.SHOW_SNACKBAR]: ({ commit }, payload) => {
    commit(types.HIDE_SNACKBAR)
    setTimeout(() => {
      commit(types.SET_SNACKBAR, payload)
      commit(types.SHOW_SNACKBAR)
    }, 250)
  },
  [types.HIDE_SNACKBAR]: ({ commit }) => {
    commit(types.HIDE_SNACKBAR)
  },
  [types.SHOW_CONFIRMATION_DIALOG]: ({ commit }, payload) => {
    commit(types.SHOW_CONFIRMATION_DIALOG, payload)
  },
  [types.HIDE_CONFIRMATION_DIALOG]: ({ commit }) => {
    commit(types.HIDE_CONFIRMATION_DIALOG)
  },
  [types.CONFIRMAR]: ({ commit }, payload) => {
    commit(types.SHOW_CONFIRMAR_DIALOG, payload)
    return new Promise((resolve, reject) => {
      commit(types.SET_CONFIRMAR_DIALOG_PROMISE_RESOLVE, {resolve: resolve})
      commit(types.SET_CONFIRMAR_DIALOG_PROMISE_REJECT, {reject: reject})
    })
  },
  [types.HIDE_CONFIRMAR_DIALOG]: ({ commit }) => {
    commit(types.HIDE_CONFIRMAR_DIALOG)
  },
  [types.GET_INFORMACAO]: async ({ commit }) => {
    try {
      const response = await informacao.getInformacao()
      commit(types.SET_INFORMACAO, { informacao: response.data })
    } catch (error) {
      commit(types.SHOW_SNACKBAR, { snackbarType: 'error', snackbarText: 'Não foi possível buscar novidades' })
    } finally {
    }
  },
  [types.SET_INFORMACAO]: ({ commit }, payload) => {
    commit(types.SET_INFORMACAO, payload)
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/ui/actions.js